import React from "react";
import { Login } from "./LoginComponents/Login";

export const LoaginMain = () => {
  return (
    <view>
      <Login />
    </view>
  );
};
